/* ===========================================================================
   BB CHECKOUT BACK: Back from checkout lands on the cart, not the builder
   ---------------------------------------------------------------------------
   When a shopper uses "Checkout Now" on the review step, the builder adds the
   box to the cart, empties itself and opens Shopify checkout. Pressing the
   browser's Back button on checkout used to return them to an empty builder,
   which looks like the box is gone (and invites building it twice). Now Back
   takes them to the cart instead, where their box is and where they can edit
   it, add another gift, or check out again.

   How: just before the builder heads to checkout, this file leaves a short-
   lived note in the browser (sessionStorage). If the builder page is then
   reached again with Back (a back/forward navigation, including the
   browser's instant "back" cache), the note sends the shopper to the cart and
   is cleared. Opening the builder any other way is unaffected, and the note
   expires after 2 hours.

   Shopify's checkout page itself can't be changed; this only changes what the
   builder does when someone comes back to it.

   Self-contained override: box-builder.js is unchanged. Remove this file's
   entry in snippets/bb-assets.liquid (both script lists) to revert.
   Added 2026-10-22.
   =========================================================================== */
(function () {
  "use strict";
  if (window.__bbCheckoutBack) return;
  window.__bbCheckoutBack = true;

  var KEY = "bb_went_to_checkout";
  var MAX_AGE_MS = 2 * 60 * 60 * 1000;

  function cartUrl() {
    return (window.BBConfig && window.BBConfig.steps && window.BBConfig.steps.cartUrl) || "/cart";
  }

  function readNote() {
    try {
      var at = Number(sessionStorage.getItem(KEY));
      if (!at) return false;
      if (Date.now() - at > MAX_AGE_MS) {
        sessionStorage.removeItem(KEY);
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function clearNote() {
    try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ }
  }

  function isBackForward() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      if (nav) return nav.type === "back_forward";
      return performance.navigation && performance.navigation.type === 2;
    } catch (e) {
      return false;
    }
  }

  function goToCart() {
    clearNote();
    window.location.replace(cartUrl());
  }

  /* Only on the builder itself. */
  if (!document.querySelector("[data-bb-builder]") || !window.BBCart) return;

  /* Came back with Back after a fresh page load. */
  if (readNote() && isBackForward()) {
    goToCart();
    return;
  }

  /* Came back from the browser's instant back cache (page restored as-is). */
  window.addEventListener("pageshow", function (event) {
    if (event.persisted && readNote()) goToCart();
  });

  /* Leave the note when the builder is about to open checkout. */
  var originalSubmit = window.BBCart.submit;
  window.BBCart.submit = function (options) {
    if (options && options.destination === "checkout" && !window.BBCart.submitting) {
      try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ }
      /* If adding to the cart fails, the shopper stays here; drop the note
         so a later Back doesn't redirect them. A successful hand-off unloads
         the page before this runs. */
      window.setTimeout(function () {
        if (!document.hidden && !window.BBCart.submitting) clearNote();
      }, 20000);
    }
    return originalSubmit.apply(this, arguments);
  };
})();
